import React, { useState, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import * as project from "../common/api/projects";
import * as impact from '../common/api/impact';
import LandingPage from "./pages/LandingPage";
import ImpactPage from "./pages/ImpactPage";

function App() {
  const merchantCode = 'AIRPORT_ACILAC';
  const [fetchedImpact, setfetchedImpact] = useState();

  useEffect(() => {
    impact.merchants(merchantCode)
      .then(response => response.json())
      .then(body => {
        setfetchedImpact(body)
      })
      .catch(error => {
        setfetchedImpact(error)
      })
  }, []);

  return (
    <>

      <Switch>
        <Route
          exact
          path={`/impact`}
          key="app-aci-lac"
        >
          <ImpactPage merchantCode={merchantCode} />
        </Route>
        <Route
          path={`/`}
          key="app-aci-lac"
        >
          <LandingPage fetchedImpact={fetchedImpact} merchantCode={merchantCode} />
        </Route>
      </Switch>
    </>
  );
}

export default App;
